<app-page>
  <app-page-title title="{{ 'SIDENAV.LEARNING-PATHS' | translate }}">
  </app-page-title>

  <div class="learning-paths-container">
    <div class="learning-paths-filters">
      <dx-text-box
        class="search-input"
        icon="search"
        width="100%"
        labelMode="floating"
        stylingMode="outlined"
        [label]="'COMMON.SEARCH' | translate"
        [value]="searchString"
        valueChangeEvent="input"
        (onValueChanged)="onSearchInput($event)"
      >
        <dxi-button
          name="search"
          type="danger"
          location="before"
          [options]="{ icon: 'search', type: 'default', disabled: true }"
        ></dxi-button>
      </dx-text-box>
    </div>
    <div class="cards-container">
      <div *ngFor="let learningPath of learningPaths" class="card-wrapper">
        <app-learning-path-card [learningPath]="learningPath" />
      </div>
    </div>
  </div>
</app-page>
